import {isEqualToOrOlderThanOffset} from "src/app/app.config";
import {threeDays, twentyFourHours} from "src/app/presentation/common/globals";

export const statusColor = (date?: Date): string => {
  if (!date) return 'color-white';

  if (isEqualToOrOlderThanOffset(date, threeDays)) {
    return 'color-danger';
  } else if (isEqualToOrOlderThanOffset(date, twentyFourHours)) {
    return 'color-warning';
  } else {
    return 'color-nominal';
  }
}
